import { UserInfo } from 'interfaces/types'

export enum CardReactionType {
  post = 1,
  reply = 2,
}

export type CommentApi = {
  content: string
  created_at: string // "2021-08-18T07:08:20.000000Z"
  created_time: string
  id: number
  image: string[] | null
  link: string | null
  replies: CommentApi[]

  liked: number
  likes_count: number
  replies_count: number
  user: {
    avatar: string
    email: string
    id: number
    name: string
    role: string
    type: string
    user_name: string
    partner_id: number
    title: string
    doctor_id: number
    hospital_id: number
  }
  mentioned: {
    avatar: string
    email: string
    id: number
    name: string
    role: string
    type: string
    user_name: string
    partner_id: number
    title: string
    doctor_id: number
    hospital_id: number
  }
  mentions?: {
    id: number
    name: string
  }[]
  is_sensitive?: number
  user_read_comment?: boolean
  source?: string[]
  is_verify?: number
  is_oppose?: number
  user_verify?: {
    avatar: string
    email: string
    id: number
    name: string
    role: string
    type: string
    user_name: string
    partner_id: number
    title: string
    doctor_id: number
    hospital_id: number
  }
  categories?: string
}

export type Comment = {
  content: string
  countLikes: number
  countReplies: number
  createdAt: string // "2021-08-18T07:08:20.000000Z"
  createdTime: string
  id: string
  images: string[] | null
  link: string | null
  replies: Comment[]
  author: UserInfo
  liked: boolean
  mentionedUser?: UserInfo
  mentions?: {
    id: number
    name: string
  }[]
  type: any
  isSensitive: number
  userReadComment: boolean
  source: string[]
  isVerify?: number
  isOppose?: number
  userVerify?: UserInfo
  categorySlug?: string
}

export type CommunityBanner = {
  id?: string
  image?: string
  mobileImage?: string
  url?: string
}

export type CommunityBannerApi = {
  image?: string
  mobile_image?: string
  url?: string
  id?: string
}

export type CommunityApi = {
  banner: CommunityBannerApi[]
  thumbnail: string
  cover_image: string
  mobile_cover_image: string
  name: string
  description: string
  topics_count: number
  posts_count: number
  members_count: number
  slug: string
  id: number
  joined: boolean
  is_active: number
  is_hidden?: number
  meta_tag?: {
    meta_title?: string
    meta_desc?: string
    meta_image?: string
  }
}

export type Community = {
  id: string
  name: string
  thumbnail?: string
  coverImage?: string
  mobileCoverImage?: string
  banner?: CommunityBanner[]
  slug?: string
  description?: string
  joined?: boolean
  topicCount?: number
  postCount?: number
  memberCount?: number
  isActive?: boolean
  isHidden?: boolean
  metaTag?: {
    metaTitle?: string
    metaDesc?: string
    metaImage?: string
  }
}

export type Topic = {
  id?: string
  name: string
  image?: string
  url?: string
  slug?: string
  description?: string
  joined?: boolean
  postCount?: number
  memberCount?: number
  community?: Community
  communityId?: string
  communitySlug?: string
  communityName?: string
  communityDesc?: string
  order?: number
  isActive?: boolean
  isHidden?: boolean
  metaTag?: {
    metaTitle?: string
    metaDesc?: string
    metaImage?: string
  }
  dueDateMonth?: number
  dueDateYear?: number
}

export type TopicApi = {
  count_members: number
  count_posts: number
  description: string
  joined: boolean
  thumbnail: string
  name: string
  id: number
  slug: string
  community: {
    id: number
    slug: string
    name: string
    description: string
  }
  order: number
  is_active: number
  is_hidden?: number
  meta_tag?: {
    meta_title?: string
    meta_desc?: string
    meta_image?: string
  }
  due_date_month?: number
  due_date_year?: number
}

export type PostApi = {
  created_at: string
  description: string
  images: string[]
  is_pin: number
  pin_date: string
  liked: boolean
  bookmarked: boolean
  commented: boolean
  id: number
  preview_title: string
  preview_description: string
  preview_link: string
  preview_image: string
  schedule_datetime: string | null
  topics?: {
    description: string
    id: number
    name: string
    slug: string
    is_hidden: number
  }[]
  slug: string
  comments_count: number
  community: {
    id: number
    slug: string
    name: string
    description: string
    is_hidden: number
  }
  created_time: string
  is_active: number
  is_anonymous: number
  is_sensitive: number
  likes_count: number
  mentions: {
    id: number
    name: string
  }[]
  name: string
  intro_url?: string
  banner_image?: string
  user: {
    avatar: string
    email: string
    id: number
    name: string
    role: string
    type: string
    user_name: string
    partner_id: number
    title: string
    doctor_id: number
    hospital_id: number
  }
}

export type Post = {
  id?: string
  community: Community
  topics?: Topic[]
  slug?: string
  // author?: UserInfo
  author?: any
  title?: string
  postTime?: string
  createdDate?: string
  scheduleDate?: string
  description?: string
  isFollowing?: boolean
  photos?: string[]
  commentCount?: number
  likeCount?: number
  commented?: boolean
  isPin?: boolean
  pinDate?: string
  isLiked?: boolean
  bookmarked?: boolean
  introUrl?: string
  isAnonymous?: number
  isAskDoctor?: number
  isSensitive?: number
  bannerImage?: string
  previewUrl?: {
    title: string
    url: string
    image?: string
    description?: string
  } | null

  moderator?: {
    name: string
    avatar: string | null
    id: number
    username?: string | null
  } | null
  mentions?: {
    id: number
    name: string
  }[]
  isReply?: boolean
}

export type ElementDataProps = 'data-event-action' | 'data-event-label'

export type ExtendingDataProps<K> = {
  [key in K extends string ? K | ElementDataProps : ElementDataProps]?:
    | string
    | number
    | boolean
    | ((e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void)
    | React.CSSProperties
} & {
  style?: React.CSSProperties
}
